var _path, _path2, _path3, _path4, _path5, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPetsWelcome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3995 31.3434C33.6676 31.3434 33.9357 31.3434 34.2574 31.2898C37.3675 30.7 39.2979 27.0537 38.5472 23.1393C37.7965 19.2249 34.6864 16.4902 31.5763 17.0801C30.0213 17.3482 28.7344 18.367 27.93 19.9756C27.1257 21.477 26.9112 23.3538 27.233 25.2306C27.93 28.7696 30.5575 31.3434 33.3995 31.3434Z",
    fill: "#103B5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9997 31.6116C25.4098 29.8958 24.2838 28.3943 22.8896 27.4828C21.4418 26.5712 19.8868 26.3031 18.439 26.7857C15.5434 27.8045 14.2029 31.6116 15.4898 35.2579C16.0797 36.9738 17.2057 38.4752 18.5999 39.3868C19.5651 40.0303 20.5839 40.352 21.5491 40.352C22.0317 40.352 22.5679 40.2448 23.0505 40.0839C25.8924 39.0651 27.233 35.2579 25.9997 31.6116Z",
    fill: "#103B5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7513 31.2898C47.0194 31.3434 47.2875 31.3434 47.6092 31.3434C50.3976 31.3434 53.0786 28.7696 53.7221 25.2306C54.0975 23.3538 53.8294 21.477 53.025 19.9756C52.2207 18.4206 50.9338 17.4018 49.3787 17.0801C46.2687 16.4902 43.1586 19.2249 42.4079 23.1393C41.7108 27.0537 43.6412 30.7 46.7513 31.2898Z",
    fill: "#103B5D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5161 26.8392C59.6205 25.874 56.2423 28.0189 55.009 31.6652C53.7757 35.3115 55.0627 39.065 58.0119 40.0838C58.4945 40.2447 58.9771 40.3519 59.5133 40.3519C60.4785 40.3519 61.4973 40.0302 62.4625 39.3867C63.8566 38.4751 64.9291 37.0274 65.5725 35.2578C66.7522 31.6116 65.4117 27.8044 62.5161 26.8392Z",
    fill: "#103B5D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.77 36.3302C43.5339 32.8984 37.421 32.8984 33.1313 36.3302C27.9836 40.4591 22.0852 46.4647 22.0852 52.0414C22.0852 65.5004 58.8161 65.5004 58.8161 52.0414C58.8698 46.4647 52.9177 40.4591 47.77 36.3302Z",
    fill: "#103B5D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "#103B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetsWelcome);
export default __webpack_public_path__ + "static/media/Pets_Welcome.f180c4b1692df84919c2a6dd008bb359.svg";
export { ForwardRef as ReactComponent };